"use strict";

var _interopRequireDefault = require("/code/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.regexp.constructor");
require("core-js/modules/es6.regexp.to-string");
var _toConsumableArray2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es6.regexp.split");
var _orderManage = require("@/api/_homeCloudPlatform/mall/orderManage.js");
var _config_treatmentplan = require("@/api/config_treatmentplan");
var _config_treatmentplan_preparations = require("@/api/config_treatmentplan_preparations");
var _memberManage = require("@/api/_homeCloudPlatform/member/memberManage.js");
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _Address = _interopRequireDefault(require("@/components/Address"));
var _mixin = _interopRequireDefault(require("./mixin.js"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var formModel = {
  return_online_order: {},
  offline_pay: []
};
var _default = exports.default = {
  mixins: [_mixin.default],
  components: {
    Pagination: _Pagination.default,
    Address: _Address.default
  },
  computed: {
    // 订单发货汇总设备数量
    // totalDeviceCnt() {
    //   let totalDeviceCnt = 0
    //   if(this.formModel.goods_online_order){
    //     this.formModel.goods_online_order.forEach(item => {
    //       totalDeviceCnt += item.device_count
    //     })
    //   } 
    //   return totalDeviceCnt
    // },
    //订单发货汇总控释盘数量
    // totalDiscCnt() {
    //   let totalDiscCnt = 0
    //   if(this.formModel.goods_online_order){
    //     this.formModel.goods_online_order.forEach(item => {
    //       totalDiscCnt += item.disc_count
    //     })
    //   } 
    //   return totalDiscCnt
    // },
    rules: function rules() {
      var _this = this;
      return {
        // --------formModel--------
        invoice_no: [
        // { required: true, message: '请输入发票号码'},
        {
          max: 30,
          message: '输入长度不能超过30位'
        }, {
          validator: function validator(rule, value, callBack) {
            var reg = /^[0-9|a-z|A-Z]*$/;
            if (value) {
              if (!reg.test(value)) {
                callBack('请输入正确的发票号码');
              } else {
                callBack();
              }
            } else {
              callBack();
            }
          }
        }],
        shipping_name: [{
          required: true,
          message: '请输入收件人'
        }, {
          max: 30,
          message: '输入长度不能超过30位'
        }],
        province_code: {
          required: true,
          message: '请选择省份'
        },
        city_code: {
          required: true,
          message: '请选择城市'
        },
        district_code: {
          required: true,
          message: '请选择区县'
        },
        addr: [{
          required: true,
          message: '请输入详细地址'
        }, {
          max: 150,
          message: '输入长度不能超过150位'
        }],
        phone: [{
          required: true,
          message: '请输入连络电话'
        }, {
          max: 20,
          message: '输入长度不能超过20位'
        }],
        // 发货单号：订单为待出货，且物流模式为1物流快递和2同城配送时为必填
        shipping_no: [{
          required: this.formModel.status === 'PROCESSING' && (this.formModel.logistics_type === 1 || this.formModel.logistics_type === 2),
          message: '请输入发货单号'
        }, {
          max: 30,
          message: '输入长度不能超过30位'
        }],
        shipping_note: [{
          max: 100,
          message: '输入长度不能超过100位'
        }],
        // 物流模式：订单为待出货，执行「出货」操作时为必填
        logistics_type: [{
          required: this.formModel.status === 'PROCESSING',
          message: '请选择物流模式'
        }],
        // 快递公司：订单为待出货，且物流模式为1物流快递和2同城配送时为必填
        express_company: [{
          required: this.formModel.status === 'PROCESSING' && (this.formModel.logistics_type === 1 || this.formModel.logistics_type === 2),
          message: '请选择快递公司'
        }],
        // ------退货信息------
        'return_online_order.reason': [{
          required: true,
          message: '请输入原因'
        }, {
          max: 100,
          message: '输入长度不能超过100位'
        }],
        'return_online_order.handle_method': [{
          required: true,
          message: '请输入处理方式'
        }, {
          max: 100,
          message: '输入长度不能超过100位'
        }],
        'return_online_order.refund_amount': [{
          required: true,
          message: '请输入退款金额'
        }, {
          validator: function validator(rule, value, callBack) {
            if (value) {
              if (value * 1 > _this.formModel.amount * 1) {
                callBack("\u4E0D\u53EF\u8D85\u8FC7\u8BA2\u5355\u91D1\u989D:".concat(_this.formModel.amount));
              } else {
                callBack();
              }
            } else {
              callBack();
            }
          }
        }],
        'return_online_order.refund_bank': [{
          required: true,
          message: '请输入退款银行'
        }, {
          max: 30,
          message: '输入长度不能超过30位'
        }],
        'return_online_order.refund_account': [{
          required: true,
          message: '请输入退款帐户'
        }, {
          max: 30,
          message: '输入长度不能超过30位'
        }],
        'return_online_order.refund_bank_account': [{
          required: true,
          message: '请输入退款银行账号'
        }, {
          max: 30,
          message: '输入长度不能超过30位'
        }],
        'return_online_order.refund_bank_branch': [{
          required: true,
          message: '请输入退款银行开户行'
        }, {
          max: 30,
          message: '输入长度不能超过30位'
        }],
        'return_online_order.return_note': [{
          max: 100,
          message: '输入长度不能超过100位'
        }],
        // --------applyFormModel--------
        //
        'reason': [{
          required: true,
          message: '请输入原因'
        }, {
          max: 100,
          message: '输入长度不能超过100位'
        }],
        'handle_method': [{
          required: true,
          message: '请输入处理方式'
        }, {
          max: 100,
          message: '输入长度不能超过100位'
        }],
        'refund_amount': [{
          required: true,
          message: '请输入退款金额'
        }, {
          validator: function validator(rule, value, callBack) {
            if ((value + '').length) {
              if (value * 1 > _this.formModel.amount * 1 || value * 1 > _this.applyFormModel.amount * 1) {
                callBack("\u4E0D\u53EF\u8D85\u8FC7\u8BA2\u5355\u91D1\u989D:".concat(_this.formModel.amount || _this.applyFormModel.amount));
              } else {
                callBack();
              }
            } else {
              callBack();
            }
          }
        }],
        'refund_bank': [{
          required: true,
          message: '请输入退款银行'
        }, {
          max: 30,
          message: '输入长度不能超过30位'
        }],
        'refund_account': [{
          required: true,
          message: '请输入退款帐户'
        }, {
          max: 30,
          message: '输入长度不能超过30位'
        }],
        'refund_bank_account': [{
          required: true,
          message: '请输入退款银行账号'
        }, {
          max: 30,
          message: '输入长度不能超过30位'
        }],
        'refund_bank_branch': [{
          required: true,
          message: '请输入退款银行开户行'
        }, {
          max: 30,
          message: '输入长度不能超过30位'
        }],
        'return_note': [{
          max: 100,
          message: '输入长度不能超过100位'
        }],
        devicesRelease: {
          trigger: 'submit',
          validator: function validator(rule, value, callBack) {
            console.log('devicesRelease value:' + JSON.stringify(value));
            console.log('totalDeviceCnt:' + _this.totalDeviceCnt);
            if (_this.totalDeviceCnt > 0) {
              if (!value) {
                callBack('请输入编号');
              } else {
                var devicesTempCount = value.split(',').filter(function (item) {
                  return item.length > 0;
                }).length;
                if (_this.totalDeviceCnt != devicesTempCount) {
                  callBack("发货设备数量不正确");
                } else {
                  callBack();
                }
              }
            } else {
              callBack();
            }
          }
        },
        discsRelease: {
          trigger: 'submit',
          validator: function validator(rule, value, callBack) {
            if (_this.totalDiscCnt > 0) {
              if (!value) {
                callBack('请输入编号');
              } else {
                var discsTempCount = value.split(',').filter(function (item) {
                  return item.length > 0;
                }).length;
                if (_this.totalDiscCnt != discsTempCount) {
                  callBack("发货控释盘数量不正确");
                } else {
                  callBack();
                }
              }
            } else {
              callBack();
            }
          }
        },
        device_number: {
          trigger: 'submit',
          validator: function validator(rule, value, callBack) {
            if (value && value.devices_disc && value.devices_disc.devicesTemp) {
              var devicesTempCount = value.devices_disc.devicesTemp.split(',').filter(function (item) {
                return item.length > 0;
              }).length;
              if (value.btnMsg &&
              //执行出货操作才验证(btnMsg: true)
              value.device_count > 0 && value.device_count != devicesTempCount) {
                callBack("发货设备数量不正确");
              }
              callBack();
            } else {
              if (value && value.btnMsg) callBack('请输入编号');
            }
          }
        },
        disc_number: {
          trigger: 'submit',
          validator: function validator(rule, value, callBack) {
            if (value && value.devices_disc && value.devices_disc.discTemp) {
              var discTempCount = value.devices_disc.discTemp.split(',').filter(function (item) {
                return item.length > 0;
              }).length;
              if (value.btnMsg &&
              //执行订单状态变更才验证(btnMsg: true)
              value.disc_count > 0 && value.disc_count != discTempCount) {
                callBack("发货控释盘数量不正确");
              }
              callBack();
            } else {
              if (value && value.btnMsg) callBack('请输入编号');
            }
          }
        },
        sale_price: {
          trigger: 'submit',
          validator: function validator(rule, value, callBack) {
            if (value && value.salePriceMsg) {
              //执行改价操作才验证(salePriceMsg: true)
              if (value.salePriceTemp && value.salePriceTemp * 1 <= 0) {
                callBack("促销价不能小于等于0");
              } else if (value.salePriceTemp && value.salePriceTemp * 1 > value.price * 1) {
                callBack("促销价不能大于售价");
              } else {
                callBack();
              }
            } else {
              callBack();
            }
          }
        },
        account: [{
          required: true,
          message: '请输入汇款帐号'
        }, {
          max: 20,
          message: '输入长度不能超过20位'
        }],
        amount: [{
          required: true,
          message: '请输入汇款金额'
        }
        // {
        //   validator: (rule, value, callBack) => {
        //   if((value+'').length){
        //     if(value*1 !== this.formModel.amount*1){
        //       callBack(`汇款金额: ${this.formModel.amount}`)
        //     }else{
        //       callBack()
        //     }
        //   }else{
        //     callBack()
        //   }
        // }},
        ],
        is_pay: [{
          required: true,
          message: '请选择是否已汇款完成'
        }],
        note: [{
          max: 100,
          message: '输入长度不能超过100位'
        }]
      };
    },
    quoteRules: function quoteRules() {
      return {
        account: [{
          required: true,
          message: '请输入11位会员帐号(手机号)'
        }],
        amount: [{
          required: true,
          message: '请输入积分'
        }]
      };
    }
  },
  watch: {
    isUpdateDiscShow: {
      immediate: true,
      handler: function handler(val) {
        if (this.isUpdateDiscShow == false) {
          this.dialogVisible = false;
        }
      }
    },
    dialogType: {
      immediate: true,
      handler: function handler(val) {
        this.disabled = val !== 'edit' && val !== 'add';
      }
    },
    'formModel.logistics_type': {
      immediate: true,
      handler: function handler(val) {
        if (this.originalFormModel.logistics_type == val) {
          this.formModel.express_company = this.originalFormModel.express_company;
        } else {
          this.formModel.express_company = '';
        }
      }
    }
  },
  data: function data() {
    return {
      loading: false,
      //dialog data loading
      dataLoaded: false,
      //address data loading control
      totalDeviceCnt: 0,
      //订单汇总设备数
      totalDiscCnt: 0,
      //订单汇总盘数
      totalPreparation: [],
      //订单汇总处方贴
      planOtherList: [],
      //planother制剂信息
      updateDiscList: '',
      discList: [],
      isUpdateDiscShow: false,
      //单盘调换
      isEditSalePriceShow: false,
      //订单改价
      return_goods_Temp: [],
      formModel: (0, _objectSpread2.default)({}, formModel),
      applyFormModel: {},
      acpFormModel: {},
      // 申请变更已付款
      checkAcpFormModel: {},
      // 审核变更已付款
      disabled: false,
      activeName: 'basicInfo',
      tableData: {},
      listLoading: true,
      // 默认排序,依创建时间递减
      defaultOrdering: '-created_at',
      defaultOrderQuotaListOrdering: '-start_time',
      listQuery: {
        page: 1,
        page_size: 20,
        page_size_before: 20,
        status: '',
        pkg_type: '',
        order_type: 1
      },
      dialogVisible: false,
      isReturnShow: false,
      // 申请退货
      dialogType: 'view',
      // 物流模式
      logisticsTypeOptions: [{
        key: 1,
        display_name: '物流快递'
      }, {
        key: 2,
        display_name: '同城配送'
      }, {
        key: 3,
        display_name: '虚拟发货'
      }, {
        key: 4,
        display_name: '用户自提'
      }],
      // 非同城(物流快递)快递公司
      notSameCityExpressOptions: [{
        key: 'SF',
        display_name: '顺丰速运'
      }, {
        key: 'JD',
        display_name: '京东快递'
      }, {
        key: 'EMS',
        display_name: 'EMS'
      }, {
        key: 'YD',
        display_name: '韵达速递'
      }, {
        key: 'ZTO',
        display_name: '中通快递'
      }, {
        key: 'YTO',
        display_name: '圆通速递'
      }, {
        key: 'STO',
        display_name: '申通快递'
      }],
      // 同城快递公司
      sameCityExpressOptions: [{
        key: 'SS',
        display_name: '闪送'
      }],
      // 状态
      // TODO 切记!!! 顺序不可对调、插队!!(请往后增加)
      statusOptions: [{
        key: 0,
        display_name: '全部'
      },
      // 0
      {
        key: 'NEW',
        display_name: '待付款'
      },
      // 1
      {
        key: 'PROCESSING',
        display_name: '待出货'
      },
      // 2
      {
        key: 'SHIPPED',
        display_name: '待收货'
      },
      // 3
      {
        key: 'DELIVERED',
        display_name: '完成'
      },
      // 4
      {
        key: 'CANCELLED',
        display_name: '取消'
      },
      // 5
      {
        key: 'RETURNING_CONFIRMING',
        display_name: '退货确认中'
      },
      // 6
      {
        key: 'RETURNING_PROCESSING',
        display_name: '退货处理中'
      },
      // 7
      {
        key: 'RETURNED',
        display_name: '退货已完成'
      },
      // 8
      {
        key: 'REFUND_CONFIRMING',
        display_name: '退款确认中'
      },
      // 9
      {
        key: 'REFUND_PROCESSING',
        display_name: '退款处理中'
      },
      // 10
      {
        key: 'REFUNDED',
        display_name: '退款已完成'
      } // 11
      ],
      // C端方案
      cEndSolutionOptions: [],
      paymentMethodOptions: [{
        key: '现金支付',
        display_name: '现金支付'
      }, {
        key: '预付款抵扣',
        display_name: '预付款抵扣'
      }, {
        key: '支付宝支付',
        display_name: '支付宝支付'
      }, {
        key: '对公账户支付',
        display_name: '对公账户支付'
      }, {
        key: '微信支付',
        display_name: '微信支付'
      }, {
        key: '抖音支付',
        display_name: '抖音支付'
      }, {
        key: '美团支付',
        display_name: '美团支付'
      }, {
        key: '大众点评支付',
        display_name: '大众点评支付'
      }, {
        key: '其他方式支付',
        display_name: '其他方式支付'
      }, {
        key: '积分全额支付',
        display_name: '积分全额支付'
      }],
      // 申请变更已付款状态
      acpStatusOptions: [{
        key: 0,
        display_name: '审核中'
      }, {
        key: 1,
        display_name: '通过审核'
      }, {
        key: 2,
        display_name: '拒绝'
      }],
      quotaModule: [{
        key: 'openHomePackage',
        display_name: '打开到家产品包'
      }, {
        key: 'openStorePackage',
        display_name: '打开到店产品包'
      }, {
        key: 'returnHomePackage',
        display_name: '退还到家产品包'
      }, {
        key: 'returnStorePackage',
        display_name: '退还到店产品包'
      }, {
        key: 'createOnlineOrder',
        display_name: '订单使用积分'
      }, {
        key: 'returnOnlineOrder',
        display_name: '退还下单使用积分'
      }, {
        key: 'adminBackendChange',
        display_name: '管理员变更积分'
      }],
      // 分润纪录
      profitRecordQuery: {
        page: 1,
        page_size: 10
      },
      profitRecordData: [],
      // 操作纪录
      optionRecordQuery: {
        online_order: "",
        page: 1,
        page_size: 10,
        count: 0,
        ordering: '',
        switch: true
      },
      // 调理码纪录查询条件
      voucherRecordQuery: {
        online_order_id: 0,
        is_package_opened: true,
        page: 1,
        page_size: 10,
        count: 0
      },
      orderQuotaListQuery: {
        page: 1,
        page_size: 10
      },
      orderQuotaList: [],
      optionRecordData: [],
      voucherRecordData: [],
      //调理码纪录
      expandedRows: [],
      //搜索调理码展开行资料
      originalFormModel: {},
      // 申请变更已付款
      isApplicationChangePaidShow: false,
      // 审核变更已付款
      isCheckAcpShow: false,
      // 查看变更已付款纪录
      isAcpRrcordShow: false,
      isQuoteShow: false,
      quoteFormModel: {},
      // 申请变更已付款
      ownerName: '',
      onlineOrderInfoQuery: {
        page: 1,
        page_size: 1000,
        page_size_before: 20
        // goods_type: 1
      }
    };
  },
  created: function created() {
    this.handleSort();
    this.getList();
    this.getcEndSolutionList();
  },
  methods: {
    checkPermission: _permission.default,
    // 取得c端方案制剂信息
    getcEndOtherList: function () {
      var _getcEndOtherList = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2(goods) {
        var _this2 = this;
        var tempData;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              tempData = [];
              _context2.next = 3;
              return Promise.all(goods.map(/*#__PURE__*/function () {
                var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(e) {
                  var res;
                  return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return (0, _config_treatmentplan_preparations.getPlanOtherList)({
                          treatmentplan: e.goods_plan_no
                        });
                      case 2:
                        res = _context.sent;
                        tempData = _this2.handlePreparations(res.data);
                        e.preparations = tempData;
                        // e.preparations = res.data;
                      case 5:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x2) {
                  return _ref.apply(this, arguments);
                };
              }()));
            case 3:
              // 等待所有非同步操作完成后再处理资料
              this.formModel.goods_online_order = (0, _toConsumableArray2.default)(goods);
              this.handleTotalPreparations(goods);
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getcEndOtherList(_x) {
        return _getcEndOtherList.apply(this, arguments);
      }
      return getcEndOtherList;
    }(),
    handlePreparations: function handlePreparations(group) {
      // 新数组，存储相同 preparations_name 和 usage_method_name 的 preparation_nums 之和
      var resultArray = [];

      // 使用对象来存储已经处理的项
      var processedItems = {};

      // 遍历原始数据
      group.forEach(function (item) {
        var key = "".concat(item.preparations_name);

        // 如果该项已经处理过，累加 preparation_nums
        if (processedItems[key]) {
          processedItems[key].preparation_nums += item.preparation_nums;
        } else {
          // 如果该项还没处理过，添加到新数组，并标记为已处理
          processedItems[key] = (0, _objectSpread2.default)({}, item);
          resultArray.push(processedItems[key]);
        }
      });
      return resultArray;
    },
    handleTotalPreparations: function handleTotalPreparations(data) {
      // 新数组，存储相同 preparations_name 和 usage_method_name 的 preparation_nums 之和
      // console.log('QQQ:'+JSON.stringify(data))
      var resultArray = [];

      // 使用对象来存储已经处理的项
      var processedItems = {};

      // 遍历原始数据
      data.forEach(function (group) {
        group.preparations.forEach(function (item) {
          var key = "".concat(item.preparations_name);

          // 如果该项已经处理过，累加 preparation_nums
          if (processedItems[key]) {
            // console.log('item.preparation_nums:'+item.preparation_nums)
            // console.log('data.goods_c_plan_times:'+group.goods_c_plan_times)
            processedItems[key].preparations_name = item.preparations_name;
            processedItems[key].total_preparation_nums += item.preparation_nums * group.goods_c_plan_times;
            // console.log('RRR:'+processedItems[key].total_preparation_nums)
          } else {
            // 如果该项还没处理过，添加到新数组，并标记为已处理
            // processedItems[key] = { ...item };
            processedItems[key] = {
              preparations_name: item.preparations_name,
              total_preparation_nums: item.preparation_nums * group.goods_c_plan_times
            };
            resultArray.push(processedItems[key]);
          }
        });
      });
      // this.totalPreparation = resultArray
      // console.log('XXXresultArray:'+ JSON.stringify(resultArray))
    },
    // c端方案清单
    getcEndSolutionList: function getcEndSolutionList() {
      var _this3 = this;
      (0, _config_treatmentplan.getTreatmentPlanList)({
        page: 1,
        page_size: 1
      }).then(function (data) {
        if (!data.data.count) return;
        (0, _config_treatmentplan.getTreatmentPlanList)({
          page_size: data.data.count,
          support_go_home: true
        }).then(function (res) {
          _this3.cEndSolutionOptions = res.data.results || [];
          _this3.cEndSolutionOptions.unshift({
            plan_title: '全部',
            id: 'all'
          });
        });
      });
    },
    // 到店调理码清单
    getVoucherList: function getVoucherList(id) {
      var _this4 = this;
      this.listLoading = true;
      this.voucherRecordQuery.online_order_id = id;
      this.voucherRecordQuery.page = 1;
      this.expandedRows = []; //清空展开行阵列 
      // this.voucherRecordQuery.page_size = 10
      // this.voucherRecordQuery.is_package_opened = true
      if (!(this.voucherRecordQuery.voucher_number + '')) {
        this.voucherRecordQuery.voucher_number = function () {
          return;
        }();
      }
      console.log('voucherRecordQuery', this.voucherRecordQuery);
      (0, _orderManage.getOnlineOrdersVoucherList)(this.voucherRecordQuery).then(function (res) {
        console.log('getVoucherList res', res);
        _this4.voucherRecordQuery.count = res.count;
        _this4.voucherRecordData = res.results || [];
        _this4.listLoading = false;
        //如搜索调理码高亮调理码并展开该行
        if (_this4.voucherRecordData && _this4.voucherRecordQuery.voucher_number + '') {
          _this4.highlight();
        }
      });
    },
    //操作调理码paginaion
    handleVoucherList: function handleVoucherList() {
      var _this5 = this;
      (0, _orderManage.getOnlineOrdersVoucherList)(this.voucherRecordQuery).then(function (res) {
        _this5.voucherRecordData = res.results || [];
        _this5.listLoading = false;
        console.log('handleVoucherList voucherRecordQuery', _this5.voucherRecordQuery);
      });
    },
    getList: function getList(e) {
      var _this6 = this;
      //避免执行条列数量切换当前页面不足产生伺服器错误
      if (e && this.listQuery.page_size_before != e.limit) {
        this.listQuery.page = 1;
        this.listQuery.page_size_before = e.limit;
      }
      this.listLoading = true;
      // this.tableData = {}
      (0, _orderManage.getOnlineOrdersList)(this.handleQuery()).then(function (res) {
        _this6.tableData = res || {};
        _this6.listLoading = false;
      });
    },
    handleView: function handleView(scope) {
      this.resetForm();
      this.handleRowData(scope.row);
      this.dialogType = 'view';
      this.dialogTitle = scope.row.id;
      //取得操作纪录
      this.getOptionRecordList(scope.row.id);
      //取得订单积分纪录
      this.getUsersQuota(scope.row.id);
      this.dialogVisible = true;
      this.activeName = 'basicInfo';
      //若为到家和到店取得商品绑定c-plan制剂资讯（产品包类型: 1:到家产品包;2:到店产品包;3:机构产品包;）
      // if(this.formModel.pkg_type !== 3){
      //   this.getcEndOtherList(scope.row.goods_online_order)
      // }
      // this.$nextTick(() => {
      //   this.$refs['Form'].clearValidate()
      // })
      // console.log('handleView formModel',this.formModel)
    },
    handleEdit: function handleEdit(scope) {
      this.resetForm();
      this.handleRowData(scope.row);
      this.dialogType = 'edit';
      this.dialogTitle = scope.row.id;
      //取得操作纪录
      this.getOptionRecordList(scope.row.id);
      //取得订单积分纪录
      this.getUsersQuota(scope.row.id);
      this.dialogVisible = true;
      this.activeName = 'basicInfo';
      //若为到家和到店取得商品绑定c-plan制剂资讯（产品包类型: 1:到家产品包;2:到店产品包;3:机构产品包;）
      // if(this.formModel.pkg_type !== 3){
      //   this.getcEndOtherList(scope.row.goods_online_order)
      // }
      // this.$nextTick(() => {
      //   this.$refs['Form'].clearValidate()
      // })
      // console.log('handleEdit formModel', JSON.stringify(this.formModel))
    },
    handleSalePrice: function handleSalePrice(scope) {
      this.resetForm();
      this.handleRowData(scope.row);
      this.dialogType = 'editSalePrice';
      this.dialogTitle = scope.row.id;
      //若为到家和到店取得商品绑定c-plan制剂资讯（产品包类型: 1:到家产品包;2:到店产品包;3:机构产品包;）
      // if(this.formModel.pkg_type !== 3){
      //   this.getcEndOtherList(scope.row.goods_online_order)
      // }
      //取得操作纪录
      // this.getOptionRecordList(scope.row.id)
      this.isEditSalePriceShow = true;
      this.activeName = 'productInfo';
      // this.$nextTick(() => {   
      //   this.$refs['Form'].clearValidate()
      // })
      // console.log('handleSalePrice formModel',this.formModel)
    },
    handleUpdateDisc: function handleUpdateDisc(scope) {
      // this.resetForm()
      // this.updateDiscFormModel = JSON.parse(JSON.stringify(scope.row))
      // this.dialogType = 'updateDisc'
      // this.isUpdateDiscShow = true
      // this.$nextTick(() => {
      //   this.$refs['applyForm'].clearValidate()
      // })
      // this.formModel = this.handleRowData(scope.row)
      // this.originalFormModel = JSON.parse(JSON.stringify(this.formModel))
      this.resetForm();
      this.handleRowData(scope.row);
      this.dialogType = 'updateDisc';
      this.dialogTitle = scope.row.id;
      //若为到家和到店取得商品绑定c-plan制剂资讯（产品包类型: 1:到家产品包;2:到店产品包;3:机构产品包;）
      // if(this.formModel.pkg_type !== 3){
      //   this.getcEndOtherList(scope.row.goods_online_order)
      // }
      //取得操作纪录
      // this.getOptionRecordList(scope.row.id)
      this.isUpdateDiscShow = true;
      this.activeName = 'productInfo';
      this.dialogVisible = true;
      // this.$nextTick(() => {   
      //   this.$refs['Form'].clearValidate()
      // })
      // console.log('handleUpdateDisc formModel',this.formModel)
    },
    handleReturn: function handleReturn(scope) {
      this.resetForm();
      if (!scope.row.can_return) {
        //产品包已打开
        this.$message({
          showClose: true,
          message: '订单产品包已打开，无法申请退款/退货',
          type: 'warning'
        });
        return;
      }
      if (scope.row.status === this.statusOptions[4].key) {
        this.dialogType = 'return'; //完成：申请退货
      } else {
        this.dialogType = 'refund'; //待出货：申请退款
      }
      this.isReturnShow = true;
      this.handleRowData(scope.row);
      console.log('handleReturn dialogType:', this.dialogType);
      // this.applyFormModel = JSON.parse(JSON.stringify(scope.row))
      // this.$nextTick(() => {
      //   this.$refs['applyForm'].clearValidate()
      // })
    },
    // 申请变更已付款
    handleApplicationChangePaid: function handleApplicationChangePaid(scope) {
      var _this7 = this;
      this.resetForm();
      // this.formModel = JSON.parse(JSON.stringify(scope.row))
      // this.handleRowData(scope.row, false)
      this.formModel.id = scope.row.id;
      this.dialogType = 'applicationChangePaid';
      this.isApplicationChangePaidShow = true;
      this.$nextTick(function () {
        _this7.$refs['acpForm'].clearValidate();
      });
    },
    // 审核变更已付款
    handleCheckAcpPaid: function handleCheckAcpPaid(scope) {
      var _this8 = this;
      this.resetForm();
      this.formModel = JSON.parse(JSON.stringify(scope.row));
      // this.handleRowData(scope.row)
      // this.formModel.id = scope.row.id
      this.dialogType = 'checkAcp';
      this.isCheckAcpShow = true;
      this.$nextTick(function () {
        _this8.$refs['checkAcpForm'].clearValidate();
      });
    },
    // 查看变更已付款纪录
    handleAcpRecordView: function handleAcpRecordView(scope) {
      this.resetForm();
      this.formModel = JSON.parse(JSON.stringify(scope.row));
      // this.formModel = this.handleRowData(scope.row)
      // this.handleRowData(scope.row)
      this.isAcpRrcordShow = true;
    },
    // 操作订单积分管理
    handleQuote: function handleQuote(scope) {
      var _this9 = this;
      this.resetForm();
      this.dialogType = 'quoteForm';
      this.formModel = JSON.parse(JSON.stringify(scope.row));
      // this.formModel = this.handleRowData(scope.row)
      // this.handleRowData(scope.row)
      this.isQuoteShow = true;
      this.$nextTick(function () {
        _this9.$refs['quoteForm'].clearValidate();
        _this9.ownerName = '';
      });
    },
    confirm: function () {
      var _confirm = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee48(form, btnMsg) {
        var _this10 = this;
        var specialJudge,
          isPass,
          isEdit,
          _args48 = arguments;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee48$(_context48) {
          while (1) switch (_context48.prev = _context48.next) {
            case 0:
              specialJudge = _args48.length > 2 && _args48[2] !== undefined ? _args48[2] : '';
              isPass = true; // 表单必填验证
              // 储存处理
              if (!btnMsg) {
                if (this.dialogType == 'edit') {
                  // 基本信息、商品信息
                  if (this.activeName === 'basicInfo' || this.activeName === 'productInfo') {
                    // this.$refs[form].validateField('invoice_no', async valid => { if(valid) isPass = false })
                    this.$refs[form].validateField('shipping_name', /*#__PURE__*/function () {
                      var _ref2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3(valid) {
                        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
                          while (1) switch (_context3.prev = _context3.next) {
                            case 0:
                              if (valid) isPass = false;
                            case 1:
                            case "end":
                              return _context3.stop();
                          }
                        }, _callee3);
                      }));
                      return function (_x5) {
                        return _ref2.apply(this, arguments);
                      };
                    }());
                    this.$refs[form].validateField('province_code', /*#__PURE__*/function () {
                      var _ref3 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee4(valid) {
                        return (0, _regeneratorRuntime2.default)().wrap(function _callee4$(_context4) {
                          while (1) switch (_context4.prev = _context4.next) {
                            case 0:
                              if (valid) isPass = false;
                            case 1:
                            case "end":
                              return _context4.stop();
                          }
                        }, _callee4);
                      }));
                      return function (_x6) {
                        return _ref3.apply(this, arguments);
                      };
                    }());
                    this.$refs[form].validateField('city_code', /*#__PURE__*/function () {
                      var _ref4 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee5(valid) {
                        return (0, _regeneratorRuntime2.default)().wrap(function _callee5$(_context5) {
                          while (1) switch (_context5.prev = _context5.next) {
                            case 0:
                              if (valid) isPass = false;
                            case 1:
                            case "end":
                              return _context5.stop();
                          }
                        }, _callee5);
                      }));
                      return function (_x7) {
                        return _ref4.apply(this, arguments);
                      };
                    }());
                    this.$refs[form].validateField('district_code', /*#__PURE__*/function () {
                      var _ref5 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee6(valid) {
                        return (0, _regeneratorRuntime2.default)().wrap(function _callee6$(_context6) {
                          while (1) switch (_context6.prev = _context6.next) {
                            case 0:
                              if (valid) isPass = false;
                            case 1:
                            case "end":
                              return _context6.stop();
                          }
                        }, _callee6);
                      }));
                      return function (_x8) {
                        return _ref5.apply(this, arguments);
                      };
                    }());
                    this.$refs[form].validateField('addr', /*#__PURE__*/function () {
                      var _ref6 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee7(valid) {
                        return (0, _regeneratorRuntime2.default)().wrap(function _callee7$(_context7) {
                          while (1) switch (_context7.prev = _context7.next) {
                            case 0:
                              if (valid) isPass = false;
                            case 1:
                            case "end":
                              return _context7.stop();
                          }
                        }, _callee7);
                      }));
                      return function (_x9) {
                        return _ref6.apply(this, arguments);
                      };
                    }());
                    this.$refs[form].validateField('phone', /*#__PURE__*/function () {
                      var _ref7 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee8(valid) {
                        return (0, _regeneratorRuntime2.default)().wrap(function _callee8$(_context8) {
                          while (1) switch (_context8.prev = _context8.next) {
                            case 0:
                              if (valid) isPass = false;
                            case 1:
                            case "end":
                              return _context8.stop();
                          }
                        }, _callee8);
                      }));
                      return function (_x10) {
                        return _ref7.apply(this, arguments);
                      };
                    }());
                    this.$refs[form].validateField('logistics_type', /*#__PURE__*/function () {
                      var _ref8 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee9(valid) {
                        return (0, _regeneratorRuntime2.default)().wrap(function _callee9$(_context9) {
                          while (1) switch (_context9.prev = _context9.next) {
                            case 0:
                              if (valid) isPass = false;
                            case 1:
                            case "end":
                              return _context9.stop();
                          }
                        }, _callee9);
                      }));
                      return function (_x11) {
                        return _ref8.apply(this, arguments);
                      };
                    }());
                    this.$refs[form].validateField('express_company', /*#__PURE__*/function () {
                      var _ref9 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee10(valid) {
                        return (0, _regeneratorRuntime2.default)().wrap(function _callee10$(_context10) {
                          while (1) switch (_context10.prev = _context10.next) {
                            case 0:
                              if (valid) isPass = false;
                            case 1:
                            case "end":
                              return _context10.stop();
                          }
                        }, _callee10);
                      }));
                      return function (_x12) {
                        return _ref9.apply(this, arguments);
                      };
                    }());
                    this.$refs[form].validateField('shipping_no', /*#__PURE__*/function () {
                      var _ref10 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee11(valid) {
                        return (0, _regeneratorRuntime2.default)().wrap(function _callee11$(_context11) {
                          while (1) switch (_context11.prev = _context11.next) {
                            case 0:
                              if (valid) isPass = false;
                            case 1:
                            case "end":
                              return _context11.stop();
                          }
                        }, _callee11);
                      }));
                      return function (_x13) {
                        return _ref10.apply(this, arguments);
                      };
                    }());
                    // 2024/5/23 設備和盤改為訂單驗證
                    this.$refs[form].validateField('devicesRelease', /*#__PURE__*/function () {
                      var _ref11 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee12(valid) {
                        return (0, _regeneratorRuntime2.default)().wrap(function _callee12$(_context12) {
                          while (1) switch (_context12.prev = _context12.next) {
                            case 0:
                              if (valid) isPass = false;
                            case 1:
                            case "end":
                              return _context12.stop();
                          }
                        }, _callee12);
                      }));
                      return function (_x14) {
                        return _ref11.apply(this, arguments);
                      };
                    }());
                    this.$refs[form].validateField('discsRelease', /*#__PURE__*/function () {
                      var _ref12 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee13(valid) {
                        return (0, _regeneratorRuntime2.default)().wrap(function _callee13$(_context13) {
                          while (1) switch (_context13.prev = _context13.next) {
                            case 0:
                              if (valid) isPass = false;
                            case 1:
                            case "end":
                              return _context13.stop();
                          }
                        }, _callee13);
                      }));
                      return function (_x15) {
                        return _ref12.apply(this, arguments);
                      };
                    }());

                    // 设备、控释盘 物件验证
                    // this.formModel.goods_online_order.forEach( (item,index) => {
                    //   item.btnMsg = false
                    //   this.$refs[form].validateField(`goods_online_order.${index}`, async valid => { if(valid) isPass = false })
                    //   this.$refs[form].validateField(`goods_online_order.${index}`, async valid => { if(valid) isPass = false })
                    // })
                  }
                  // 退货信息
                  else if (this.activeName === 'returnInfo') {
                    this.$refs[form].validateField('return_online_order.reason', /*#__PURE__*/function () {
                      var _ref13 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee14(valid) {
                        return (0, _regeneratorRuntime2.default)().wrap(function _callee14$(_context14) {
                          while (1) switch (_context14.prev = _context14.next) {
                            case 0:
                              if (valid) isPass = false;
                            case 1:
                            case "end":
                              return _context14.stop();
                          }
                        }, _callee14);
                      }));
                      return function (_x16) {
                        return _ref13.apply(this, arguments);
                      };
                    }());
                    this.$refs[form].validateField('return_online_order.handle_method', /*#__PURE__*/function () {
                      var _ref14 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee15(valid) {
                        return (0, _regeneratorRuntime2.default)().wrap(function _callee15$(_context15) {
                          while (1) switch (_context15.prev = _context15.next) {
                            case 0:
                              if (valid) isPass = false;
                            case 1:
                            case "end":
                              return _context15.stop();
                          }
                        }, _callee15);
                      }));
                      return function (_x17) {
                        return _ref14.apply(this, arguments);
                      };
                    }());
                    this.$refs[form].validateField('return_online_order.refund_amount', /*#__PURE__*/function () {
                      var _ref15 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee16(valid) {
                        return (0, _regeneratorRuntime2.default)().wrap(function _callee16$(_context16) {
                          while (1) switch (_context16.prev = _context16.next) {
                            case 0:
                              if (valid) isPass = false;
                            case 1:
                            case "end":
                              return _context16.stop();
                          }
                        }, _callee16);
                      }));
                      return function (_x18) {
                        return _ref15.apply(this, arguments);
                      };
                    }());
                    this.$refs[form].validateField('return_online_order.refund_bank', /*#__PURE__*/function () {
                      var _ref16 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee17(valid) {
                        return (0, _regeneratorRuntime2.default)().wrap(function _callee17$(_context17) {
                          while (1) switch (_context17.prev = _context17.next) {
                            case 0:
                              if (valid) isPass = false;
                            case 1:
                            case "end":
                              return _context17.stop();
                          }
                        }, _callee17);
                      }));
                      return function (_x19) {
                        return _ref16.apply(this, arguments);
                      };
                    }());
                    this.$refs[form].validateField('return_online_order.refund_account', /*#__PURE__*/function () {
                      var _ref17 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee18(valid) {
                        return (0, _regeneratorRuntime2.default)().wrap(function _callee18$(_context18) {
                          while (1) switch (_context18.prev = _context18.next) {
                            case 0:
                              if (valid) isPass = false;
                            case 1:
                            case "end":
                              return _context18.stop();
                          }
                        }, _callee18);
                      }));
                      return function (_x20) {
                        return _ref17.apply(this, arguments);
                      };
                    }());
                    this.$refs[form].validateField('return_online_order.refund_bank_account', /*#__PURE__*/function () {
                      var _ref18 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee19(valid) {
                        return (0, _regeneratorRuntime2.default)().wrap(function _callee19$(_context19) {
                          while (1) switch (_context19.prev = _context19.next) {
                            case 0:
                              if (valid) isPass = false;
                            case 1:
                            case "end":
                              return _context19.stop();
                          }
                        }, _callee19);
                      }));
                      return function (_x21) {
                        return _ref18.apply(this, arguments);
                      };
                    }());
                    this.$refs[form].validateField('return_online_order.refund_bank_branch', /*#__PURE__*/function () {
                      var _ref19 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee20(valid) {
                        return (0, _regeneratorRuntime2.default)().wrap(function _callee20$(_context20) {
                          while (1) switch (_context20.prev = _context20.next) {
                            case 0:
                              if (valid) isPass = false;
                            case 1:
                            case "end":
                              return _context20.stop();
                          }
                        }, _callee20);
                      }));
                      return function (_x22) {
                        return _ref19.apply(this, arguments);
                      };
                    }());
                    this.$refs[form].validateField('return_online_order.return_note', /*#__PURE__*/function () {
                      var _ref20 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee21(valid) {
                        return (0, _regeneratorRuntime2.default)().wrap(function _callee21$(_context21) {
                          while (1) switch (_context21.prev = _context21.next) {
                            case 0:
                              if (valid) isPass = false;
                            case 1:
                            case "end":
                              return _context21.stop();
                          }
                        }, _callee21);
                      }));
                      return function (_x23) {
                        return _ref20.apply(this, arguments);
                      };
                    }());
                  }
                }
                // 申请退货
                if (this.dialogType === 'return') {
                  this.$refs[form].validateField('reason', /*#__PURE__*/function () {
                    var _ref21 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee22(valid) {
                      return (0, _regeneratorRuntime2.default)().wrap(function _callee22$(_context22) {
                        while (1) switch (_context22.prev = _context22.next) {
                          case 0:
                            if (valid) isPass = false;
                          case 1:
                          case "end":
                            return _context22.stop();
                        }
                      }, _callee22);
                    }));
                    return function (_x24) {
                      return _ref21.apply(this, arguments);
                    };
                  }());
                  this.$refs[form].validateField('handle_method', /*#__PURE__*/function () {
                    var _ref22 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee23(valid) {
                      return (0, _regeneratorRuntime2.default)().wrap(function _callee23$(_context23) {
                        while (1) switch (_context23.prev = _context23.next) {
                          case 0:
                            if (valid) isPass = false;
                          case 1:
                          case "end":
                            return _context23.stop();
                        }
                      }, _callee23);
                    }));
                    return function (_x25) {
                      return _ref22.apply(this, arguments);
                    };
                  }());
                  this.$refs[form].validateField('refund_amount', /*#__PURE__*/function () {
                    var _ref23 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee24(valid) {
                      return (0, _regeneratorRuntime2.default)().wrap(function _callee24$(_context24) {
                        while (1) switch (_context24.prev = _context24.next) {
                          case 0:
                            if (valid) isPass = false;
                          case 1:
                          case "end":
                            return _context24.stop();
                        }
                      }, _callee24);
                    }));
                    return function (_x26) {
                      return _ref23.apply(this, arguments);
                    };
                  }());
                  this.$refs[form].validateField('refund_bank', /*#__PURE__*/function () {
                    var _ref24 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee25(valid) {
                      return (0, _regeneratorRuntime2.default)().wrap(function _callee25$(_context25) {
                        while (1) switch (_context25.prev = _context25.next) {
                          case 0:
                            if (valid) isPass = false;
                          case 1:
                          case "end":
                            return _context25.stop();
                        }
                      }, _callee25);
                    }));
                    return function (_x27) {
                      return _ref24.apply(this, arguments);
                    };
                  }());
                  this.$refs[form].validateField('refund_account', /*#__PURE__*/function () {
                    var _ref25 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee26(valid) {
                      return (0, _regeneratorRuntime2.default)().wrap(function _callee26$(_context26) {
                        while (1) switch (_context26.prev = _context26.next) {
                          case 0:
                            if (valid) isPass = false;
                          case 1:
                          case "end":
                            return _context26.stop();
                        }
                      }, _callee26);
                    }));
                    return function (_x28) {
                      return _ref25.apply(this, arguments);
                    };
                  }());
                  this.$refs[form].validateField('refund_bank_account', /*#__PURE__*/function () {
                    var _ref26 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee27(valid) {
                      return (0, _regeneratorRuntime2.default)().wrap(function _callee27$(_context27) {
                        while (1) switch (_context27.prev = _context27.next) {
                          case 0:
                            if (valid) isPass = false;
                          case 1:
                          case "end":
                            return _context27.stop();
                        }
                      }, _callee27);
                    }));
                    return function (_x29) {
                      return _ref26.apply(this, arguments);
                    };
                  }());
                  this.$refs[form].validateField('refund_bank_branch', /*#__PURE__*/function () {
                    var _ref27 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee28(valid) {
                      return (0, _regeneratorRuntime2.default)().wrap(function _callee28$(_context28) {
                        while (1) switch (_context28.prev = _context28.next) {
                          case 0:
                            if (valid) isPass = false;
                          case 1:
                          case "end":
                            return _context28.stop();
                        }
                      }, _callee28);
                    }));
                    return function (_x30) {
                      return _ref27.apply(this, arguments);
                    };
                  }());
                  this.$refs[form].validateField('return_note', /*#__PURE__*/function () {
                    var _ref28 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee29(valid) {
                      return (0, _regeneratorRuntime2.default)().wrap(function _callee29$(_context29) {
                        while (1) switch (_context29.prev = _context29.next) {
                          case 0:
                            if (valid) isPass = false;
                          case 1:
                          case "end":
                            return _context29.stop();
                        }
                      }, _callee29);
                    }));
                    return function (_x31) {
                      return _ref28.apply(this, arguments);
                    };
                  }());
                }
                // 申请变更已付款
                if (this.dialogType === 'applicationChangePaid') {
                  this.$refs[form].validateField('account', /*#__PURE__*/function () {
                    var _ref29 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee30(valid) {
                      return (0, _regeneratorRuntime2.default)().wrap(function _callee30$(_context30) {
                        while (1) switch (_context30.prev = _context30.next) {
                          case 0:
                            if (valid) isPass = false;
                          case 1:
                          case "end":
                            return _context30.stop();
                        }
                      }, _callee30);
                    }));
                    return function (_x32) {
                      return _ref29.apply(this, arguments);
                    };
                  }());
                  this.$refs[form].validateField('amount', /*#__PURE__*/function () {
                    var _ref30 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee31(valid) {
                      return (0, _regeneratorRuntime2.default)().wrap(function _callee31$(_context31) {
                        while (1) switch (_context31.prev = _context31.next) {
                          case 0:
                            if (valid) isPass = false;
                          case 1:
                          case "end":
                            return _context31.stop();
                        }
                      }, _callee31);
                    }));
                    return function (_x33) {
                      return _ref30.apply(this, arguments);
                    };
                  }());
                  this.$refs[form].validateField('is_pay', /*#__PURE__*/function () {
                    var _ref31 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee32(valid) {
                      return (0, _regeneratorRuntime2.default)().wrap(function _callee32$(_context32) {
                        while (1) switch (_context32.prev = _context32.next) {
                          case 0:
                            if (valid) isPass = false;
                          case 1:
                          case "end":
                            return _context32.stop();
                        }
                      }, _callee32);
                    }));
                    return function (_x34) {
                      return _ref31.apply(this, arguments);
                    };
                  }());
                }
                // 审核变更已付款
                if (this.dialogType === 'checkAcp') {
                  // 拒绝
                  if (specialJudge === 'rejectAcp') {}
                }
                // 确认订单积分管理
                if (this.dialogType === 'quoteForm') {
                  this.$refs[form].validateField('account', /*#__PURE__*/function () {
                    var _ref32 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee33(valid) {
                      return (0, _regeneratorRuntime2.default)().wrap(function _callee33$(_context33) {
                        while (1) switch (_context33.prev = _context33.next) {
                          case 0:
                            if (valid) isPass = false;
                          case 1:
                          case "end":
                            return _context33.stop();
                        }
                      }, _callee33);
                    }));
                    return function (_x35) {
                      return _ref32.apply(this, arguments);
                    };
                  }());
                  this.$refs[form].validateField('amount', /*#__PURE__*/function () {
                    var _ref33 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee34(valid) {
                      return (0, _regeneratorRuntime2.default)().wrap(function _callee34$(_context34) {
                        while (1) switch (_context34.prev = _context34.next) {
                          case 0:
                            if (valid) isPass = false;
                          case 1:
                          case "end":
                            return _context34.stop();
                        }
                      }, _callee34);
                    }));
                    return function (_x36) {
                      return _ref33.apply(this, arguments);
                    };
                  }());
                }
                // 订单改价编辑促销价
                if (this.dialogType === 'editSalePrice') {
                  this.formModel.goods_online_order.forEach(function (item, index) {
                    item.salePriceMsg = true;
                    _this10.$refs[form].validateField("goods_online_order.".concat(index), /*#__PURE__*/function () {
                      var _ref34 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee35(valid) {
                        return (0, _regeneratorRuntime2.default)().wrap(function _callee35$(_context35) {
                          while (1) switch (_context35.prev = _context35.next) {
                            case 0:
                              if (valid) isPass = false;
                            case 1:
                            case "end":
                              return _context35.stop();
                          }
                        }, _callee35);
                      }));
                      return function (_x37) {
                        return _ref34.apply(this, arguments);
                      };
                    }());
                  });
                }
              }
              // 处理订单状态
              else {
                // 出货 , 需验证发票号码 、 发货单号、物流模式、快递公司
                if (this.formModel.status === this.statusOptions[2].key) {
                  // this.$refs[form].validateField('invoice_no', async valid => { if(valid) isPass = false })
                  this.$refs[form].validateField('shipping_no', /*#__PURE__*/function () {
                    var _ref35 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee36(valid) {
                      return (0, _regeneratorRuntime2.default)().wrap(function _callee36$(_context36) {
                        while (1) switch (_context36.prev = _context36.next) {
                          case 0:
                            if (valid) isPass = false;
                          case 1:
                          case "end":
                            return _context36.stop();
                        }
                      }, _callee36);
                    }));
                    return function (_x38) {
                      return _ref35.apply(this, arguments);
                    };
                  }());
                  this.$refs[form].validateField('shipping_note', /*#__PURE__*/function () {
                    var _ref36 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee37(valid) {
                      return (0, _regeneratorRuntime2.default)().wrap(function _callee37$(_context37) {
                        while (1) switch (_context37.prev = _context37.next) {
                          case 0:
                            if (valid) isPass = false;
                          case 1:
                          case "end":
                            return _context37.stop();
                        }
                      }, _callee37);
                    }));
                    return function (_x39) {
                      return _ref36.apply(this, arguments);
                    };
                  }());
                  this.$refs[form].validateField('shipping_name', /*#__PURE__*/function () {
                    var _ref37 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee38(valid) {
                      return (0, _regeneratorRuntime2.default)().wrap(function _callee38$(_context38) {
                        while (1) switch (_context38.prev = _context38.next) {
                          case 0:
                            if (valid) isPass = false;
                          case 1:
                          case "end":
                            return _context38.stop();
                        }
                      }, _callee38);
                    }));
                    return function (_x40) {
                      return _ref37.apply(this, arguments);
                    };
                  }());
                  this.$refs[form].validateField('province_code', /*#__PURE__*/function () {
                    var _ref38 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee39(valid) {
                      return (0, _regeneratorRuntime2.default)().wrap(function _callee39$(_context39) {
                        while (1) switch (_context39.prev = _context39.next) {
                          case 0:
                            if (valid) isPass = false;
                          case 1:
                          case "end":
                            return _context39.stop();
                        }
                      }, _callee39);
                    }));
                    return function (_x41) {
                      return _ref38.apply(this, arguments);
                    };
                  }());
                  this.$refs[form].validateField('city_code', /*#__PURE__*/function () {
                    var _ref39 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee40(valid) {
                      return (0, _regeneratorRuntime2.default)().wrap(function _callee40$(_context40) {
                        while (1) switch (_context40.prev = _context40.next) {
                          case 0:
                            if (valid) isPass = false;
                          case 1:
                          case "end":
                            return _context40.stop();
                        }
                      }, _callee40);
                    }));
                    return function (_x42) {
                      return _ref39.apply(this, arguments);
                    };
                  }());
                  this.$refs[form].validateField('district_code', /*#__PURE__*/function () {
                    var _ref40 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee41(valid) {
                      return (0, _regeneratorRuntime2.default)().wrap(function _callee41$(_context41) {
                        while (1) switch (_context41.prev = _context41.next) {
                          case 0:
                            if (valid) isPass = false;
                          case 1:
                          case "end":
                            return _context41.stop();
                        }
                      }, _callee41);
                    }));
                    return function (_x43) {
                      return _ref40.apply(this, arguments);
                    };
                  }());
                  this.$refs[form].validateField('addr', /*#__PURE__*/function () {
                    var _ref41 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee42(valid) {
                      return (0, _regeneratorRuntime2.default)().wrap(function _callee42$(_context42) {
                        while (1) switch (_context42.prev = _context42.next) {
                          case 0:
                            if (valid) isPass = false;
                          case 1:
                          case "end":
                            return _context42.stop();
                        }
                      }, _callee42);
                    }));
                    return function (_x44) {
                      return _ref41.apply(this, arguments);
                    };
                  }());
                  this.$refs[form].validateField('phone', /*#__PURE__*/function () {
                    var _ref42 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee43(valid) {
                      return (0, _regeneratorRuntime2.default)().wrap(function _callee43$(_context43) {
                        while (1) switch (_context43.prev = _context43.next) {
                          case 0:
                            if (valid) isPass = false;
                          case 1:
                          case "end":
                            return _context43.stop();
                        }
                      }, _callee43);
                    }));
                    return function (_x45) {
                      return _ref42.apply(this, arguments);
                    };
                  }());
                  this.$refs[form].validateField('logistics_type', /*#__PURE__*/function () {
                    var _ref43 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee44(valid) {
                      return (0, _regeneratorRuntime2.default)().wrap(function _callee44$(_context44) {
                        while (1) switch (_context44.prev = _context44.next) {
                          case 0:
                            if (valid) isPass = false;
                          case 1:
                          case "end":
                            return _context44.stop();
                        }
                      }, _callee44);
                    }));
                    return function (_x46) {
                      return _ref43.apply(this, arguments);
                    };
                  }());
                  this.$refs[form].validateField('express_company', /*#__PURE__*/function () {
                    var _ref44 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee45(valid) {
                      return (0, _regeneratorRuntime2.default)().wrap(function _callee45$(_context45) {
                        while (1) switch (_context45.prev = _context45.next) {
                          case 0:
                            if (valid) isPass = false;
                          case 1:
                          case "end":
                            return _context45.stop();
                        }
                      }, _callee45);
                    }));
                    return function (_x47) {
                      return _ref44.apply(this, arguments);
                    };
                  }());

                  // 2024/5/23 設備和盤改為訂單驗證
                  this.$refs[form].validateField('devicesRelease', /*#__PURE__*/function () {
                    var _ref45 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee46(valid) {
                      return (0, _regeneratorRuntime2.default)().wrap(function _callee46$(_context46) {
                        while (1) switch (_context46.prev = _context46.next) {
                          case 0:
                            if (valid) isPass = false;
                          case 1:
                          case "end":
                            return _context46.stop();
                        }
                      }, _callee46);
                    }));
                    return function (_x48) {
                      return _ref45.apply(this, arguments);
                    };
                  }());
                  this.$refs[form].validateField('discsRelease', /*#__PURE__*/function () {
                    var _ref46 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee47(valid) {
                      return (0, _regeneratorRuntime2.default)().wrap(function _callee47$(_context47) {
                        while (1) switch (_context47.prev = _context47.next) {
                          case 0:
                            if (valid) isPass = false;
                          case 1:
                          case "end":
                            return _context47.stop();
                        }
                      }, _callee47);
                    }));
                    return function (_x49) {
                      return _ref46.apply(this, arguments);
                    };
                  }());

                  // 设备、控释盘 物件验证
                  // this.formModel.goods_online_order.forEach( (item,index) => {
                  //   item.btnMsg = true
                  //   this.$refs[form].validateField(`goods_online_order.${index}`, async valid => { if(valid) isPass = false })
                  //   this.$refs[form].validateField(`goods_online_order.${index}`, async valid => { if(valid) isPass = false })
                  // })
                }
              }
              // -------------------------------------------
              isEdit = this.dialogType === 'edit';
              if (!isPass) {
                _context48.next = 8;
                break;
              }
              this.handleFormData(btnMsg, specialJudge);
              _context48.next = 10;
              break;
            case 8:
              if (isEdit && this.activeName === 'basicInfo' || this.activeName === 'productInfo') {
                this.$message({
                  showClose: true,
                  message: '基本信息 或 商品信息,未填写完整!',
                  type: 'warning'
                });
              }
              return _context48.abrupt("return", false);
            case 10:
            case "end":
              return _context48.stop();
          }
        }, _callee48, this);
      }));
      function confirm(_x3, _x4) {
        return _confirm.apply(this, arguments);
      }
      return confirm;
    }(),
    handleRowData: function () {
      var _handleRowData = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee49(data) {
        var _this11 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee49$(_context49) {
          while (1) switch (_context49.prev = _context49.next) {
            case 0:
              this.dataLoaded = false; //地址元件待資料載入後再渲染
              this.loading = true; //資料載入中效果
              this.onlineOrderInfoQuery.online_order_no = data.order_no;

              //处理商品清单 (Light減肥版)
              _context49.next = 5;
              return (0, _orderManage.getGoodsList)(this.onlineOrderInfoQuery).then(function (res) {
                console.log('getGoodsList:', res.results);
                data.goods_online_order = res.results;
                // 因应elementUI,须把阵列转字串
                data.goods_online_order.forEach(function (item) {
                  // 设备
                  _this11.$set(item.devices_disc, 'devicesTemp', item.devices_disc.device_numbers.join());
                  // 控释盘
                  _this11.$set(item.devices_disc, 'discTemp', item.devices_disc.disc_numbers.join());
                  // 促销价
                  _this11.$set(item, 'salePriceTemp', item.sale_price);
                });

                // 退货信息
                if (data.hasOwnProperty("return_online_order") && data.return_online_order) {
                  if (data.return_online_order.hasOwnProperty("return_goods_online_order")) {
                    _this11.return_goods_Temp = [];
                    data.return_online_order.return_goods_online_order.forEach(function (item) {
                      // 退货信息 退货商品默认选中处理
                      _this11.return_goods_Temp.push(item.goods_online_order);
                    });
                  }
                }
                // console.log('FFFF:'+JSON.stringify(data))
                data.devicesRelease = "";
                data.discsRelease = "";
                _this11.formModel = JSON.parse(JSON.stringify(data));
                _this11.originalFormModel = JSON.parse(JSON.stringify(_this11.formModel));
                _this11.applyFormModel = JSON.parse(JSON.stringify(_this11.formModel));
                _this11.loading = false;
                _this11.dataLoaded = true;
                // console.log('this.formModel:'+JSON.stringify(this.formModel))

                // 處理表單驗證reset
                _this11.$nextTick(function () {
                  //this.$refs['Form'].clearValidate()
                  if (_this11.dialogType == 'return' || _this11.dialogType == 'refund') {
                    _this11.$refs['applyForm'].clearValidate();
                  } else {
                    _this11.$refs['Form'].clearValidate();
                  }
                });
                //若为到家和到店取得商品绑定c-plan制剂资讯（产品包类型: 1:到家产品包;2:到店产品包;3:机构产品包;）
                // if(this.formModel.pkg_type !== 3){
                //   this.getcEndOtherList(this.formModel.goods_online_order)
                // }
              });
            case 5:
              //处理订单汇总
              (0, _orderManage.getGoodsSum)({
                online_order_id: data.id
              }).then(function (res) {
                console.log('getGoodsSum:', res);
                _this11.totalDeviceCnt = res.total_device_count;
                _this11.totalDiscCnt = res.total_disc_count;
                var originalUsage = res.usage_methods;
                console.log('ddd:' + _this11.formModel.devicesRelease);
                if (res.device_online_order_shipping && JSON.stringify(res.device_online_order_shipping) != "{}") {
                  _this11.formModel.devicesRelease = res.device_online_order_shipping ? res.device_online_order_shipping["".concat(data.id)].online_order_device_list.toString() : "";
                } else {
                  _this11.formModel.devicesRelease = "";
                }
                if (res.device_online_order_shipping && JSON.stringify(res.device_online_order_shipping) != "{}") {
                  _this11.formModel.discsRelease = res.device_online_order_shipping ? res.device_online_order_shipping["".concat(data.id)].online_order_disc_list.toString() : "";
                } else {
                  _this11.formModel.discsRelease = "";
                }
                // this.formModel.discsRelease = res.device_online_order_shipping ? res.device_online_order_shipping[`${data.id}`].online_order_disc_list.toString() : []

                //处理不同穴位但同方合併制剂数量
                var resultArray = []; //处理后制剂阵列
                var processedItems = {}; // 使用对象来存储已经处理的项
                originalUsage.forEach(function (item) {
                  var key = "".concat(item.preparation_name);
                  // 如果该项已经处理过，累加total_preparation_count
                  if (processedItems[key]) {
                    processedItems[key].preparation_name = item.preparation_name;
                    processedItems[key].total_preparation_count += item.total_preparation_count;
                  } else {
                    // 如果该项还没处理过，添加到新数组，并标记为已处理
                    processedItems[key] = {
                      preparation_name: item.preparation_name,
                      total_preparation_count: item.total_preparation_count
                    };
                    resultArray.push(processedItems[key]);
                  }
                });
                _this11.totalPreparation = resultArray;
                console.log('totalPreparation:', _this11.totalPreparation);
              });
              console.log('handleRowData formModel:', this.formModel);
              //若为檢視或編輯到店订单取得调理码纪录
              if ((this.dialogType === 'edit' || this.dialogType === 'view') && this.formModel.pkg_type === 2) {
                this.getVoucherList(data.id);
              }
              //处理商品清单
              // getGoodsOnlineOrders(this.onlineOrderInfoQuery).then(res => {
              //   data.goods_online_order = res.results
              //   // 因应elementUI,须把阵列转字串
              //   data.goods_online_order.forEach( item=> {
              //     // 设备
              //     this.$set(item.devices_disc,'devicesTemp',item.devices_disc.device_numbers.join())
              //     // 控释盘
              //     this.$set(item.devices_disc,'discTemp',item.devices_disc.disc_numbers.join())
              //     // 促销价
              //     this.$set(item,'salePriceTemp', item.sale_price)
              //   })

              //   // 退货信息
              //   if(data.hasOwnProperty("return_online_order") && data.return_online_order) {
              //     if(data.return_online_order.hasOwnProperty("return_goods_online_order")) {
              //       this.return_goods_Temp=[]
              //       data.return_online_order.return_goods_online_order.forEach(item=>{
              //         // 退货信息 退货商品默认选中处理
              //         this.return_goods_Temp.push(item.goods_online_order)
              //       })
              //     }
              //   }
              //   // console.log('FFFF:'+JSON.stringify(data))

              //   this.formModel = JSON.parse(JSON.stringify(data))
              //   this.originalFormModel = JSON.parse(JSON.stringify(this.formModel))
              //   this.loading = false
              //   this.dataLoaded = true
              //   //若为到家和到店取得商品绑定c-plan制剂资讯（产品包类型: 1:到家产品包;2:到店产品包;3:机构产品包;）
              //   // if(this.formModel.pkg_type !== 3){
              //   //   this.getcEndOtherList(this.formModel.goods_online_order)
              //   // }
              // })  
            case 8:
            case "end":
              return _context49.stop();
          }
        }, _callee49, this);
      }));
      function handleRowData(_x50) {
        return _handleRowData.apply(this, arguments);
      }
      return handleRowData;
    }(),
    handleFormData: function () {
      var _handleFormData = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee50(btnMsg, specialJudge) {
        var _this12 = this;
        var params, commonMethod, _this$formModel, invoice_no, shipping_name, province_code, city_code, district_code, addr, phone, shipping_no, shipping_note, logistics_type, express_company, goods_online_order, return_online_order, isEdit, reason, handle_method, refund_amount, refund_bank, refund_account, refund_bank_account, refund_bank_branch, return_note, id, return_goods_online_order, _this$applyFormModel, _id, _reason, _handle_method, _refund_amount, _refund_bank, _refund_account, _refund_bank_account, _refund_bank_branch, _return_note, _goods_online_order, returnType, changeStatus, _this$acpFormModel, amount, account, is_pay, note, pay_method, review_note, title, totalSalePrice, status, nextStatus, errFlag, _this$formModel2, _invoice_no, _shipping_name, _province_code, _city_code, _district_code, _addr, _phone, _shipping_no, _shipping_note, _logistics_type, _express_company, _goods_online_order2, _return_online_order, putParams, _this$formModel$retur, _reason2, _handle_method2, _refund_amount2, _refund_bank2, _refund_account2, _refund_bank_account2, _refund_bank_branch2, _return_note2, _id2, _return_goods_online_order, refund;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee50$(_context50) {
          while (1) switch (_context50.prev = _context50.next) {
            case 0:
              params = {};
              commonMethod = function commonMethod(title) {
                _this12.getList();
                _this12.dialogVisible = false;
                _this12.isReturnShow = false;
                _this12.isApplicationChangePaidShow = false;
                _this12.isCheckAcpShow = false;
                _this12.isQuoteShow = false;
                _this12.isEditSalePriceShow = false;
                _this12.$message({
                  message: "".concat(title, "\u6210\u529F"),
                  type: 'success'
                });
              }; // 储存处理
              if (btnMsg) {
                _context50.next = 51;
                break;
              }
              // common data
              _this$formModel = this.formModel, invoice_no = _this$formModel.invoice_no, shipping_name = _this$formModel.shipping_name, province_code = _this$formModel.province_code, city_code = _this$formModel.city_code, district_code = _this$formModel.district_code, addr = _this$formModel.addr, phone = _this$formModel.phone, shipping_no = _this$formModel.shipping_no, shipping_note = _this$formModel.shipping_note, logistics_type = _this$formModel.logistics_type, express_company = _this$formModel.express_company, goods_online_order = _this$formModel.goods_online_order, return_online_order = _this$formModel.return_online_order;
              isEdit = this.dialogType === 'edit';
              if (!isEdit) {
                _context50.next = 9;
                break;
              }
              // 基本信息、商品信息
              if (this.activeName === 'basicInfo' || this.activeName === 'productInfo') {
                params = {
                  // 设备编号、控释盘编号处理
                  goods_online_order: this.devicesDiscHandler(),
                  invoice_no: invoice_no,
                  shipping_name: shipping_name,
                  province_code: province_code,
                  city_code: city_code,
                  district_code: district_code,
                  addr: addr,
                  phone: phone,
                  shipping_no: function () {
                    if (_this12.formModel.status === 'PROCESSING' && (_this12.formModel.logistics_type === 1 || _this12.formModel.logistics_type === 2)) {
                      return shipping_no;
                    } else {
                      return;
                    }
                  }(),
                  shipping_note: shipping_note,
                  logistics_type: logistics_type,
                  express_company: express_company,
                  online_order_device_list: this.formModel.devicesRelease != "" ? this.formModel.devicesRelease.split(",") : [],
                  online_order_disc_list: this.formModel.discsRelease != "" ? this.formModel.discsRelease.split(",") : []
                  // devicesRelease,
                  // discsRelease
                };
                // let totalSalePrice = 0
                // params.goods_online_order.forEach(element => {
                //   totalSalePrice += element.sale_price
                // });
                // console.log('TTT:'+totalSalePrice)
                // console.log('FFF:'+this.formModel.point)
                // if(totalSalePrice<=this.formModel.point && this.formModel.status =="NEW") {
                //   this.$message({
                //     message: '商品促销价总金额不能低于或等于使用积分',
                //     type: 'warning'
                //   });              
                //   return false
                // }
                (0, _orderManage.updateOnlineOrder)(this.formModel.id, params).then(function (res) {
                  if (res.status_code !== 200) {
                    return _this12.errorHandle(res);
                  }
                  commonMethod('编辑');
                });
              }
              // 退货信息
              else if (this.activeName === 'returnInfo') {
                reason = return_online_order.reason, handle_method = return_online_order.handle_method, refund_amount = return_online_order.refund_amount, refund_bank = return_online_order.refund_bank, refund_account = return_online_order.refund_account, refund_bank_account = return_online_order.refund_bank_account, refund_bank_branch = return_online_order.refund_bank_branch, return_note = return_online_order.return_note, id = return_online_order.id, return_goods_online_order = return_online_order.return_goods_online_order;
                params = {
                  online_order: this.formModel.id,
                  // 原订单id
                  reason: reason,
                  handle_method: handle_method,
                  refund_amount: refund_amount,
                  refund_bank: refund_bank,
                  refund_account: refund_account,
                  refund_bank_account: refund_bank_account,
                  refund_bank_branch: refund_bank_branch,
                  return_note: return_note,
                  return_goods_online_order: this.returnGoodsHandler()
                };
                (0, _orderManage.updateReturnOnlineOrder)(id, params).then(function (res) {
                  if (res.status_code !== 200) {
                    return _this12.errorHandle(res);
                  }
                  commonMethod('编辑');
                });
              }
              _context50.next = 49;
              break;
            case 9:
              if (!(this.dialogType === 'return' || this.dialogType === 'refund')) {
                _context50.next = 21;
                break;
              }
              _this$applyFormModel = this.applyFormModel, _id = _this$applyFormModel.id, _reason = _this$applyFormModel.reason, _handle_method = _this$applyFormModel.handle_method, _refund_amount = _this$applyFormModel.refund_amount, _refund_bank = _this$applyFormModel.refund_bank, _refund_account = _this$applyFormModel.refund_account, _refund_bank_account = _this$applyFormModel.refund_bank_account, _refund_bank_branch = _this$applyFormModel.refund_bank_branch, _return_note = _this$applyFormModel.return_note, _goods_online_order = _this$applyFormModel.goods_online_order;
              returnType = 0;
              changeStatus = '';
              if (this.dialogType === 'return') {
                returnType = 1; //退货
                changeStatus = this.statusOptions[6].key; //状态变更为'退货确认中' 
              } else {
                returnType = 2; //退款
                changeStatus = this.statusOptions[9].key; //状态变更为'退款确认中'
              }
              console.log('returnType:', returnType);
              console.log('changeStatus:', changeStatus);
              params = {
                online_order: _id,
                // 原订单id
                reason: _reason,
                handle_method: _handle_method,
                refund_amount: _refund_amount,
                refund_bank: _refund_bank,
                refund_account: _refund_account,
                refund_bank_account: _refund_bank_account,
                refund_bank_branch: _refund_bank_branch,
                return_note: _return_note,
                return_goods_online_order: function () {
                  var result = [];
                  if (_this12.dialogType === 'return') {
                    //退货回传商品清单
                    if (_goods_online_order.length) {
                      _goods_online_order.forEach(function (item) {
                        result.push({
                          'goods_online_order': item.id
                        });
                      });
                    }
                    return result;
                  } else {
                    //退款不回传商品清单
                    return;
                  }
                }(),
                return_type: returnType
              };
              console.log('createReturnOnlineOrder params:', params);
              (0, _orderManage.createReturnOnlineOrder)(params).then(function (res) {
                if (res.status_code !== 200) {
                  return _this12.errorHandle(res);
                }
                // 更换订单状态
                (0, _orderManage.updateOnlineOrderStatus)(_id, {
                  status: changeStatus
                }).then(function (res) {
                  if (res.status_code !== 200) {
                    return _this12.errorHandle(res);
                  }
                  commonMethod('申请');
                });
              });
              _context50.next = 49;
              break;
            case 21:
              if (!(this.dialogType === 'applicationChangePaid')) {
                _context50.next = 27;
                break;
              }
              _this$acpFormModel = this.acpFormModel, amount = _this$acpFormModel.amount, account = _this$acpFormModel.account, is_pay = _this$acpFormModel.is_pay, note = _this$acpFormModel.note, pay_method = _this$acpFormModel.pay_method;
              params = {
                online_order: this.formModel.id,
                amount: amount,
                account: account,
                is_pay: is_pay,
                note: note,
                pay_method: pay_method
              };
              (0, _orderManage.createOfflinePay)(params).then(function (res) {
                if (res.status_code !== 200) {
                  return _this12.errorHandle(res);
                }
                commonMethod('申请变更已付款');
              });
              _context50.next = 49;
              break;
            case 27:
              if (!(this.dialogType === 'checkAcp')) {
                _context50.next = 34;
                break;
              }
              review_note = this.checkAcpFormModel.review_note, title = "通过审核";
              params = {
                status: 1,
                // 审核状态: 0:审核中, 1:通过审核, 2:拒绝
                review_note: review_note
              };
              if (specialJudge === 'rejectAcp') {
                params.status = 2;
                title = "拒绝";
              } else {
                params.status = 1;
              }
              (0, _orderManage.updateOfflinePay)(this.formModel.offline_pay[0].id, params).then(function (res) {
                if (res.status_code !== 200) {
                  return _this12.errorHandle(res);
                }
                commonMethod(title);
              });
              _context50.next = 49;
              break;
            case 34:
              if (!(this.dialogType === 'quoteForm')) {
                _context50.next = 39;
                break;
              }
              // let {
              //   amount,
              //   account,
              //   note,
              // } = this.quoteFormModel
              params = {
                online_order_id: this.formModel.id,
                point: this.quoteFormModel.amount,
                account: this.quoteFormModel.account,
                note: this.quoteFormModel.note
              };
              (0, _memberManage.postUsersQuota)(params).then(function (res) {
                if (res.status_code !== 200) {
                  return _this12.errorHandle(res);
                }
                commonMethod('订单积分管理异动');
              });
              _context50.next = 49;
              break;
            case 39:
              if (!(this.dialogType === 'editSalePrice')) {
                _context50.next = 49;
                break;
              }
              if (!(this.activeName === 'productInfo')) {
                _context50.next = 49;
                break;
              }
              params = {
                // 设备编号、控释盘编号处理
                goods_online_order: this.devicesDiscHandler()
              };
              // 验证促销价总额不可低于使用积分
              totalSalePrice = 0;
              params.goods_online_order.forEach(function (element) {
                totalSalePrice += element.sale_price;
              });
              // console.log('TTT:'+totalSalePrice)
              // console.log('FFF:'+this.formModel.point)
              if (!(totalSalePrice <= this.formModel.point && this.formModel.status == "NEW")) {
                _context50.next = 48;
                break;
              }
              this.$message({
                message: '商品促销价总金额不能低于或等于使用积分',
                type: 'warning'
              });
              console.log('totalSalePrice', totalSalePrice);
              return _context50.abrupt("return", false);
            case 48:
              (0, _orderManage.updateOnlineOrder)(this.formModel.id, params).then(function (res) {
                if (res.status_code !== 200) {
                  return _this12.errorHandle(res);
                }
                commonMethod('编辑');
              });
            case 49:
              _context50.next = 87;
              break;
            case 51:
              status = this.formModel.status;
              nextStatus = '';
              errFlag = false;
              _context50.t0 = status;
              _context50.next = _context50.t0 === this.statusOptions[2].key ? 57 : _context50.t0 === this.statusOptions[3].key ? 63 : _context50.t0 === this.statusOptions[6].key ? 65 : _context50.t0 === this.statusOptions[7].key ? 71 : _context50.t0 === this.statusOptions[9].key ? 73 : _context50.t0 === this.statusOptions[10].key ? 81 : _context50.t0 === this.statusOptions[1].key ? 83 : 85;
              break;
            case 57:
              nextStatus = this.statusOptions[3].key;

              // 填完资料后送出,再切状态
              _this$formModel2 = this.formModel, _invoice_no = _this$formModel2.invoice_no, _shipping_name = _this$formModel2.shipping_name, _province_code = _this$formModel2.province_code, _city_code = _this$formModel2.city_code, _district_code = _this$formModel2.district_code, _addr = _this$formModel2.addr, _phone = _this$formModel2.phone, _shipping_no = _this$formModel2.shipping_no, _shipping_note = _this$formModel2.shipping_note, _logistics_type = _this$formModel2.logistics_type, _express_company = _this$formModel2.express_company, _goods_online_order2 = _this$formModel2.goods_online_order, _return_online_order = _this$formModel2.return_online_order;
              putParams = {
                goods_online_order: this.devicesDiscHandler(),
                invoice_no: _invoice_no,
                shipping_name: _shipping_name,
                province_code: _province_code,
                city_code: _city_code,
                district_code: _district_code,
                addr: _addr,
                phone: _phone,
                shipping_no: _shipping_no,
                shipping_note: _shipping_note,
                logistics_type: _logistics_type,
                express_company: _express_company,
                // online_order_device_list:this.formModel.devicesRelease.split(","),
                // online_order_disc_list:this.formModel.discsRelease.split(","),
                online_order_device_list: this.formModel.devicesRelease != "" ? this.formModel.devicesRelease.split(",") : [],
                online_order_disc_list: this.formModel.discsRelease != "" ? this.formModel.discsRelease.split(",") : []
                // devicesRelease: null,
                // discsRelease: ""
              };
              _context50.next = 62;
              return (0, _orderManage.updateOnlineOrder)(this.formModel.id, putParams).then(function (res) {
                if (res.status_code !== 200) {
                  errFlag = true;
                  return _this12.errorHandle(res);
                }
              });
            case 62:
              return _context50.abrupt("break", 85);
            case 63:
              nextStatus = this.statusOptions[4].key;
              return _context50.abrupt("break", 85);
            case 65:
              nextStatus = this.statusOptions[7].key;
              _this$formModel$retur = this.formModel.return_online_order, _reason2 = _this$formModel$retur.reason, _handle_method2 = _this$formModel$retur.handle_method, _refund_amount2 = _this$formModel$retur.refund_amount, _refund_bank2 = _this$formModel$retur.refund_bank, _refund_account2 = _this$formModel$retur.refund_account, _refund_bank_account2 = _this$formModel$retur.refund_bank_account, _refund_bank_branch2 = _this$formModel$retur.refund_bank_branch, _return_note2 = _this$formModel$retur.return_note, _id2 = _this$formModel$retur.id, _return_goods_online_order = _this$formModel$retur.return_goods_online_order;
              params = {
                online_order: this.formModel.id,
                // 原订单id
                reason: _reason2,
                handle_method: _handle_method2,
                refund_amount: _refund_amount2,
                refund_bank: _refund_bank2,
                refund_account: _refund_account2,
                refund_bank_account: _refund_bank_account2,
                refund_bank_branch: _refund_bank_branch2,
                return_note: _return_note2,
                return_goods_online_order: this.returnGoodsHandler()
              };
              _context50.next = 70;
              return (0, _orderManage.updateReturnOnlineOrder)(_id2, params).then(function (res) {
                if (res.status_code !== 200) {
                  errFlag = true;
                  return _this12.errorHandle(res);
                }
              });
            case 70:
              return _context50.abrupt("break", 85);
            case 71:
              nextStatus = this.statusOptions[8].key;
              return _context50.abrupt("break", 85);
            case 73:
              nextStatus = this.statusOptions[10].key;
              refund = JSON.parse(JSON.stringify(this.formModel.return_online_order));
              console.log('refund', refund);
              params = {
                online_order: this.formModel.id,
                // 原订单id
                reason: refund.reason,
                handle_method: refund.handle_method,
                refund_amount: refund.refund_amount,
                refund_bank: refund.refund_bank,
                refund_account: refund.refund_account,
                refund_bank_account: refund.refund_bank_account,
                refund_bank_branch: refund.refund_bank_branch,
                return_note: refund.return_note
                // return_goods_online_order: this.returnGoodsHandler()
              };
              console.log('退款处理中params', params);
              _context50.next = 80;
              return (0, _orderManage.updateReturnOnlineOrder)(refund.id, params).then(function (res) {
                if (res.status_code !== 200) {
                  errFlag = true;
                  return _this12.errorHandle(res);
                }
              });
            case 80:
              return _context50.abrupt("break", 85);
            case 81:
              nextStatus = this.statusOptions[11].key;
              return _context50.abrupt("break", 85);
            case 83:
              nextStatus = this.statusOptions[5].key;
              return _context50.abrupt("break", 85);
            case 85:
              params.status = nextStatus;
              if (!errFlag) {
                (0, _orderManage.updateOnlineOrderStatus)(this.formModel.id, params).then(function (res) {
                  if (res.status_code !== 200) {
                    return _this12.errorHandle(res);
                  }
                  commonMethod('');
                });
              }
            case 87:
            case "end":
              return _context50.stop();
          }
        }, _callee50, this);
      }));
      function handleFormData(_x51, _x52) {
        return _handleFormData.apply(this, arguments);
      }
      return handleFormData;
    }(),
    handleClick: function handleClick(tab, event) {
      // console.log(tab, event)
      // 分润纪录
      if (this.activeName === 'profitRecord') {
        this.profitRecordQuery = {
          page: 1,
          page_size: 10
        };
        this.getProfitRecordList();
      }
      setTimeout(function () {
        document.querySelector('.listContainer').scrollTop = 0;
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    highlight: function highlight() {
      var _this13 = this;
      //搜索字voucherRecordQuery.voucher_number
      var searchText = this.voucherRecordQuery.voucher_number;
      console.log('highlight searchText', searchText);
      //遍历商品和遍历调理码，取代符合的字串
      // let itemList = JSON.parse(JSON.stringify(this.voucherRecordData))
      this.voucherRecordData.forEach(function (item, index) {
        item.treatment_vouchers.forEach(function (voucher, index) {
          if (searchText) {
            var replaceReg = new RegExp(searchText, "ig");
            var replaceString = "<span style=\"color: #0066FF\">".concat(searchText, "</span>");
            item.treatment_vouchers[index].voucher_number = voucher.voucher_number.replace(replaceReg, replaceString);
            // console.log('replaceReg, replaceString',replaceReg, replaceString)
            // console.log('item',item.treatment_vouchers[index].voucher_number)

            //将符合搜寻条件的行加入展开阵列
            if (!_this13.expandedRows.includes(item.id)) {
              _this13.expandedRows.push(item.id);
            } else {
              return;
            }
            console.log('expandedRows', _this13.expandedRows);
          }
        });
      });
      // 使用 $nextTick 确保在 DOM 更新后再执行
      this.$nextTick(function () {
        //使用 $refs 之前确保它存在，使用 toggleRowExpansion 方法展开对应的行
        if (_this13.$refs.voucherRecordData && _this13.$refs.voucherRecordData.toggleRowExpansion) {
          console.log('this.$refs.voucherRecordData', _this13.$refs.voucherRecordData);
          _this13.expandedRows.forEach(function (rowId) {
            _this13.$refs.voucherRecordData.toggleRowExpansion(rowId);
          });
        }
      });
      //强制更新
      this.$forceUpdate();
    },
    // handleRowExpand(row, expanded) {
    //   if (expanded) {
    //     // 将展开的行的键加入expandedRows数组
    //     // this.expandedRows.push(row.id); 
    //     return
    //   } else {
    //     // 将收缩的行的键从expandedRows数组中移除
    //     const index = this.expandedRows.indexOf(row.id);
    //     if (index !== -1) {
    //       this.expandedRows.splice(index, 1);
    //     }
    //   }
    // },
    tableRowClassName: function tableRowClassName(_ref47) {
      var row = _ref47.row,
        rowIndex = _ref47.rowIndex;
      if (rowIndex === 0) {
        return 'warning-row';
      } else if (rowIndex === 3) {
        return 'warning-row';
      }
      return '';
    },
    resetFilter: function resetFilter() {
      this.listQuery = {
        page: 1,
        page_size: this.listQuery.page_size,
        ordering: this.listQuery.ordering,
        order_type: 1
      };
      this.getList();
    },
    handleQuery: function handleQuery() {
      var query = (0, _objectSpread2.default)({}, this.listQuery);
      if (query.status === '' || query.status === 0) {
        query.status = function () {
          return;
        }();
      }
      if (!(query.order_no + '')) {
        query.order_no = function () {
          return;
        }();
      }
      if (!(query.account + '')) {
        query.account = function () {
          return;
        }();
      }
      if (query.c_plan === '' || query.c_plan === 'all') {
        query.c_plan = function () {
          return;
        }();
      }
      // 产品包
      if (query.pkg_type === '' || query.pkg_type === 'all') {
        query.pkg_type = function () {
          return;
        }();
      }
      return query;
    },
    handleSort: function handleSort(column) {
      // 初始化处理
      if (!column) {
        this.listQuery.ordering = this.listQuery.ordering || this.defaultOrdering;
        return {
          prop: this.defaultOrdering.indexOf('-') !== -1 ? this.defaultOrdering.split('-')[1] : this.defaultOrdering,
          order: this.defaultOrdering.indexOf('-') !== -1 ? 'descending' : 'ascending'
        };
      }
      // 点击排序
      else {
        this.listQuery.page = 1;
        this.listQuery.ordering = column.order ? "".concat(column.order === 'descending' ? '-' : '').concat(column.prop) : this.defaultOrdering;
        this.getList();
      }
    },
    // TODO get 分润纪录
    getProfitRecordList: function getProfitRecordList() {
      // this.listLoading = true
      // getStocksList({
      //   page:this.profitRecordData.page,
      //   page_size: this.profitRecordData.page_size,
      //   goods:this.formModel.goods
      // }).then(res => {
      //   this.profitRecordData = res || []
      //   this.listLoading = false
      // })
    },
    // TODO get 操作纪录
    getOptionRecordList: function getOptionRecordList(id) {
      var _this14 = this;
      this.listLoading = true;
      this.optionRecordQuery.online_order = id;
      this.optionRecordQuery.page = 1;
      (0, _orderManage.getWorkingLog)(this.optionRecordQuery).then(function (res) {
        _this14.optionRecordQuery.count = res.count;
        _this14.optionRecordData = res.data || [];
        _this14.listLoading = false;
      });
    },
    //操作纪录paginaion
    handleRecordList: function handleRecordList() {
      var _this15 = this;
      (0, _orderManage.getWorkingLog)(this.optionRecordQuery).then(function (res) {
        _this15.optionRecordData = res.data || [];
        _this15.listLoading = false;
      });
    },
    //操作纪录排序
    handleRecordSort: function handleRecordSort(column) {
      var _this16 = this;
      var ordering = "";
      var turn = "";
      if (column) {
        switch (column.prop) {
          case '操作时间':
            ordering = "working_time";
            break;
          case '操作人员':
            ordering = "name";
            break;
          case '内容':
            ordering = "working_log";
            break;
        }
        if (column.order == "descending") {
          turn = '-';
        }
        this.optionRecordQuery.ordering = turn + ordering;
        this.optionRecordQuery.page = 1;
      }
      (0, _orderManage.getWorkingLog)(this.optionRecordQuery).then(function (res) {
        _this16.optionRecordData = res.data || [];
        _this16.listLoading = false;
      });
    },
    handleOrderSalePriceDisabled: function handleOrderSalePriceDisabled() {
      var isDisabled = true;
      // 类型为订单改价,且订单为待付款可改价
      // console.log('console.log(this.dialogType):'+this.dialogType)
      // console.log('this.formModel.status:'+this.formModel.status)
      if (
      // !this.disabled &&
      this.dialogType === 'editSalePrice' && this.formModel.status === this.statusOptions[1].key) {
        isDisabled = false;
      }
      return isDisabled;
    },
    handleOrderStatusDisabled: function handleOrderStatusDisabled() {
      var isDisabled = true;
      // 非查看,且订单为待付款、待出货可编辑
      if (this.dialogType !== 'view' && (this.formModel.status === this.statusOptions[1].key || this.formModel.status === this.statusOptions[2].key)) {
        isDisabled = false;
      }
      return isDisabled;
    },
    handleReturnOrderStatusDisabled: function handleReturnOrderStatusDisabled() {
      var isDisabled = true;
      // 订单为完成、退货确认中、退款确认中可编辑退款/退货信息
      if (this.formModel.status === this.statusOptions[4].key || this.formModel.status === this.statusOptions[6].key || this.formModel.status === this.statusOptions[9].key) {
        isDisabled = false;
      }
      return isDisabled;
    },
    // 处理设备编号、控释盘编号
    devicesDiscHandler: function devicesDiscHandler() {
      var _this17 = this;
      // --------------------------------------------
      var result = [],
        isDiff = false,
        devices = [],
        discs = [];
      this.originalFormModel.goods_online_order.forEach(function (originalItem) {
        devices = [];
        discs = [];
        _this17.formModel.goods_online_order.slice().forEach(function (item) {
          // 是否为同一订单
          if (item.id === originalItem.id) {
            // ---------------device_numbers handle-----------------
            item.devices_disc.devicesTemp.split(',').forEach(function (deviceNumbersItem) {
              // 设备编号 --> item.devices_disc.devicesTemp
              // 控释盘编号 --> item.devices_disc.discTemp
              // push新增的编号
              if (!originalItem.devices_disc.device_numbers.includes(deviceNumbersItem)) {
                if ((deviceNumbersItem + '').length > 0) devices.push(deviceNumbersItem);
              } else {
                // 已存在也要
                devices.push(deviceNumbersItem);
              }
            });
            result.push({
              id: item.id,
              devices_disc: {
                device_numbers: !item.devices_disc.devicesTemp ? [] : devices
              }
            });

            // ---------------disc_numbers handle-----------------
            item.devices_disc.discTemp.split(',').forEach(function (discNumbersItem) {
              // 若原本就有控释盘编号
              if (!originalItem.devices_disc.disc_numbers.includes(discNumbersItem)) {
                if ((discNumbersItem + '').length > 0) discs.push(discNumbersItem);
              }
              // 若原本无控释盘编号
              else {
                discs.push(discNumbersItem);
              }
            });
            result.forEach(function (resultItem) {
              if (resultItem.id === item.id) {
                resultItem.devices_disc.disc_numbers = !item.devices_disc.discTemp ? [] : discs;
                resultItem.sale_price = !item.salePriceTemp ? 0 : item.salePriceTemp;
              }
            });

            // ---------------sale_price handle-----------------
          }
        });
      });
      // console.log("@@@:", result)
      return result;
    },
    // 处理退货商品ID
    returnGoodsHandler: function returnGoodsHandler() {
      var _this18 = this;
      // return_goods_Temp 放了goodsID
      var result = [];
      if (this.formModel.goods_online_order.length) {
        this.formModel.goods_online_order.forEach(function (item) {
          if (_this18.return_goods_Temp.includes(item.id)) {
            result.push({
              'goods_online_order': item.id
            });
          }
        });
      }
      return result;
    },
    // 清空表单
    resetForm: function resetForm() {
      this.formModel = formModel;
      this.applyFormModel = {};
      this.acpFormModel = {};
      this.checkAcpFormModel = {};
      this.quoteFormModel = {};
      this.updateDiscList = '';
      this.voucherRecordQuery = {
        //还原默认值清除调理码搜寻
        online_order_id: 0,
        is_package_opened: true,
        page: 1,
        page_size: 10,
        count: 0
      };
    },
    removeDisc: function removeDisc(goodsItem, tag) {
      var _this19 = this;
      if (confirm("确定移除此控释盘？")) {
        // deleteGoodsOnlineOrdersDisc
        var arr = [];
        arr.push(tag);
        var obj = {
          "disc_numbers": arr
        };
        (0, _orderManage.deleteGoodsOnlineOrdersDisc)(goodsItem.id, obj).then(function (res) {
          if (res.status_code == '200') {
            _this19.$message({
              message: '移除成功',
              type: 'success'
            });
            _this19.getList();
            _this19.isUpdateDiscShow = false;
          } else {
            return _this19.errorHandle(res);
          }
        });
      }
    },
    confirmUpdateDisc: function confirmUpdateDisc(goodsItem) {
      var _this20 = this;
      var item = this.updateDiscList;
      item = item.replace(/\s/g, "");
      if (item == '') {
        this.$message({
          message: '请输入新发货控释盘编号',
          type: 'warning'
        });
      } else {
        // let arr = []
        var arr = item.split(',');
        // arr.push(item)
        var obj = {
          "disc_numbers": arr
        };
        (0, _orderManage.createGoodsOnlineOrdersDisc)(goodsItem.id, obj).then(function (res) {
          if (res.status_code == '200') {
            _this20.$message({
              message: '加入成功',
              type: 'success'
            });
            _this20.getList();
            _this20.isUpdateDiscShow = false;
            // this.dialogVisible = false
          } else {
            return _this20.errorHandle(res);
          }
        });
      }
    },
    // 取得会员积分纪录
    getUsersQuota: function getUsersQuota(online_order_id) {
      var _this21 = this;
      this.listLoading = true;
      (0, _memberManage.getUsersQuota)({
        page: this.orderQuotaListQuery.page,
        page_size: this.orderQuotaListQuery.page_size,
        ordering: this.orderQuotaListQuery.ordering,
        online_order_id: online_order_id
      }).then(function (res) {
        _this21.orderQuotaList = res;
        _this21.listLoading = false;
      });
    },
    // 订单积分排序
    orderQuotaListSort: function orderQuotaListSort(column) {
      // 初始化处理
      if (!column) {
        this.orderQuotaListQuery.ordering = this.orderQuotaListQuery.ordering || this.defaultOrderQuotaListOrdering;
        return {
          prop: this.defaultOrderQuotaListOrdering.indexOf('-') !== -1 ? this.defaultOrderQuotaListOrdering.split('-')[1] : this.defaultOrderQuotaListOrdering,
          order: this.defaultOrderQuotaListOrdering.indexOf('-') !== -1 ? 'descending' : 'ascending'
        };
      }
      // 点击排序
      else {
        // 订单标号特殊处理
        // if(column.prop == 'online_order_order_no'){ column.prop = 'online_order__order_no' }
        this.orderQuotaListQuery.ordering = column.order ? "".concat(column.order === 'descending' ? '-' : '').concat(column.prop) : this.defaultOrderQuotaListOrdering;
        this.getUsersQuota();
      }
    },
    getName: function getName() {
      var _this22 = this;
      if (this.quoteFormModel.account.length == 11) {
        var listQuery = {
          page: 1,
          page_size: 1,
          account: this.quoteFormModel.account
        };
        (0, _memberManage.getUsersList)(listQuery).then(function (response) {
          if (response.results.length > 0) {
            _this22.ownerName = response.results[0].name;
            _this22.quoteFormModel.accountId = response.results[0].id;
          } else {
            _this22.$message({
              message: '请输入正确会员帐号(手机号)',
              type: 'warning'
            });
          }
          _this22.listLoading = false;
          // })
        });
      } else {
        this.$message({
          message: '请输入11位会员帐号(手机号)',
          type: 'warning'
        });
      }
    }
  }
};